



















import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { ExtraVariation } from '@/api';
import CurrencyField from '@/components/CurrencyField.vue';

@Component({
  components: { CurrencyField },
})
export default class extends Vue {
  @Prop({ required: true }) readonly item: ExtraVariation;
  loading: boolean = false;

  async updatePrice() {
    try {
      this.loading = true;
      await this.item.save();
    } catch (e) {
      // Error
    } finally {
      this.loading = false;
    }
  }
}
